import $ from 'jquery'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'chart.js'
import './component.scss'

const RADAR_CHART_TARGET_SELECTOR = '.js-radarChart-target'

$(() => {
  const $radarChartTarget = $(RADAR_CHART_TARGET_SELECTOR)
  if ($radarChartTarget.length === 0) {
    return
  }
  const data = $radarChartTarget.data('chart')
  const { labels, datasets } = data

  new Chart($radarChartTarget, {
    type: 'radar',
    data: {
      labels: labels,
      datasets: datasets
    },
    options: {
      scale: {
        ticks: {
          display: false,
          min: 0,
          max: 5,
          stepSize: 1
        },
        pointLabels: {
          fontSize: 12,
          fontColor: '#808891'
        }
      },
      legend: {
        display: false
      },
      title: {
        display: false
      }
    }
  })
})
